import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "details",
  "use": "details-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"details\"><path fill-rule=\"evenodd\" d=\"M14 13v-2h8v2h-8Zm0-6v2h6V7h-6Zm8 10v-2h-8v2h8Zm-10-1c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol